import React, { memo, useEffect, useMemo } from "react";
import { useMastersContext } from "../../../../contexts/masters.context";

function DecoMethodNameSelectFilter({ column }) {
  const { filterValue, setFilter } = column;
  const { decoMethodsState } = useMastersContext();

  const options = useMemo(() => decoMethodsState.data.map((dm) => dm.name), [
    decoMethodsState.data,
  ]);

  return (
    <>
      <select
        className="custom-select custom-select-sm"
        onChange={(e) => setFilter(e.currentTarget.value)}
        defaultValue={filterValue || ""}
      >
        <option value="">All</option>
        {options.map((value, i) => (
          <option value={value} key={i}>
            {value}
          </option>
        ))}
      </select>
    </>
  );
}

export default memo(DecoMethodNameSelectFilter);
